/* import __COLOCATED_TEMPLATE__ from './local-speaker.hbs'; */
import { classNames } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { initials, trimmedName } from 'frontend/utils/name-utils';
import { modifier } from 'ember-modifier';
import { not, reads } from '@ember/object/computed';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './local-speaker.module.scss';

@classic
@classNames(styles.component)
export default class TwilioLocalSpeaker extends Component {
  @service('twilio/room') twilioRoom;
  @service('twilio/preflight') preflightService;
  @service audioVideoAdapter;
  @service session;

  @reads('twilioRoom.roomModel.featureTwilioPeerToPeer') featureTwilioPeerToPeer;
  @reads('twilioRoom.disableNetworkQualityIndicator') disableNetworkQualityIndicator;
  @reads('twilioRoom.videoTrack') videoTrack;
  @reads('preflightService.networkQualityScore') networkLevel;
  @reads('session.userData.profileImageUrl') profileImageUrl;
  @not('twilioRoom.isAudioPublished') muted;

  @computed('twilioRoom.userName')
  get name() {
    return {
      initials: initials(this.twilioRoom.userName),
      trimmedName: trimmedName(this.twilioRoom.userName),
    };
  }

  @computed('twilioRoom.uniqRandom')
  get logoColor() {
    return this.twilioRoom.uniqRandom.getItem(0).toString();
  }

  initVideo = modifier(async videoElement => {
    this.audioVideoAdapter.attachMediaSource({ element: videoElement, source: this.videoTrack });
  });
}
